import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const ApplePayCaption = ({ type  })=>{
    const { getLabel  } = useIntl();
    let descriptionText;
    switch(type){
        case 'navigate-to-express-checkout':
            descriptionText = getLabel('checkout.express.apple.pay.action.continue');
            break;
        case 'express-checkout':
            descriptionText = getLabel('checkout.express.apple.pay.action.checkout');
            break;
        case 'regular-checkout':
            descriptionText = getLabel('checkout.express.apple.pay.action.payWith');
            break;
    }
    return /*#__PURE__*/ React.createElement("span", {
        className: "apple-pay-caption"
    }, type && descriptionText, /*#__PURE__*/ React.createElement(Icon, {
        color: "white",
        name: "apple-checkout-button-icon"
    }), getLabel('checkout.express.apple.pay.action.pay'));
};
const ApplePayButton = ({ disabled , type , onClick  })=>{
    const caption = /*#__PURE__*/ React.createElement(ApplePayCaption, {
        type: type
    });
    return /*#__PURE__*/ React.createElement(Button, {
        disabled: disabled,
        className: "cart-navigation__button apple-pay",
        "data-t": type,
        caption: caption,
        onClick: onClick
    });
};

export { ApplePayButton };
//# sourceMappingURL=ApplePayButton.js.map
